import { render, staticRenderFns } from "./JessibucaVideo.vue?vue&type=template&id=281b8289&"
import script from "./JessibucaVideo.vue?vue&type=script&lang=js&"
export * from "./JessibucaVideo.vue?vue&type=script&lang=js&"
import style0 from "./JessibucaVideo.vue?vue&type=style&index=0&id=281b8289&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports